// Keep the marketing import stable while sharing the catalog with the MCP server.
export { MCP_TOOL_COUNT, MCP_TOOL_GROUPS } from '@workspace/common/mcp-catalog';
export type {
  McpTool,
  McpToolEffect,
  McpToolGroup
} from '@workspace/common/mcp-catalog';
